import { atom } from "recoil";

export const gazetteerState = atom({
    key: "gazetteerState",
    default: {} as GazetteerStore,
});

export interface GazetteerStore {
    localGazetteerUrl?: string;
    localGazetteerToken?: string;
    nationalGazetteerUrl?: string;
    nationalGazetteerToken?: string;
}
